// extracted by mini-css-extract-plugin
export default {"search":"search__-Wdi0"};